import type {ConsumptionRequestDTO} from './_requests'

export type RobMachineryRow = {machinery: string; consumed: string; rob: string}

export type RobOuterRow = {
  fieldType: string
  initialRob: string
  lastRob: string
  machineries: RobMachineryRow[]
}

export function defaultEmptyRobRow(): RobOuterRow {
  return {
    fieldType: '',
    initialRob: '',
    lastRob: '',
    machineries: [{machinery: '', consumed: '', rob: ''}],
  }
}

export function mapConsumptionResponseToRows(data: {rows?: unknown} | null | undefined): RobOuterRow[] {
  const rows = data?.rows
  if (!Array.isArray(rows) || rows.length === 0) {
    return [defaultEmptyRobRow()]
  }
  return rows.map((r: any) => {
    const machList = Array.isArray(r?.machineries) && r.machineries.length ? r.machineries : [{}]
    return {
      fieldType: String(r?.fieldType ?? ''),
      initialRob: r?.initialRob != null && r.initialRob !== '' ? String(r.initialRob) : '',
      lastRob: r?.lastRob != null && r.lastRob !== '' ? String(r.lastRob) : '',
      machineries: machList.map((m: any) => ({
        machinery: String(m?.machinery ?? ''),
        consumed: m?.consumed != null && m.consumed !== '' ? String(m.consumed) : '',
        rob: m?.rob != null && m.rob !== '' ? String(m.rob) : '',
      })),
    }
  })
}

/**
 * Build payload for POST /api/consumption/submit. Scope is enforced server-side on voyage.
 */
export function buildConsumptionRequestDto(
  rows: RobOuterRow[],
  voyageId: number,
  userId: number,
  companyId: number,
  reportId?: number
): ConsumptionRequestDTO {
  const mappedRows = rows
    .filter((r) => r.fieldType && r.fieldType !== 'Select Fuel Type')
    .map((r) => ({
      fieldType: r.fieldType,
      initialRob: Number.parseFloat(String(r.initialRob)) || 0,
      lastRob: Number.parseFloat(String(r.lastRob)) || 0,
      machineries: r.machineries
        .filter((m) => String(m.machinery || '').trim())
        .map((m) => ({
          machinery: m.machinery.trim(),
          operationType: '',
          consumed: Number.parseFloat(String(m.consumed)) || 0,
          rob: Number.parseFloat(String(m.rob)) || 0,
        })),
    }))

  const dto: ConsumptionRequestDTO = {
    voyageId,
    userId,
    companyId,
    rows: mappedRows,
  }
  if (reportId != null && reportId > 0) {
    dto.reportId = reportId
  }
  return dto
}
